import React from 'react';

type PillButtonType = {
  tagColor: string;
  tagName: string;
  handleFilter: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PillButton = ({ tagColor, tagName, handleFilter }: PillButtonType) => {
  const customClassName = () => {
    switch (tagColor) {
      case 'orange':
        return 'text-white bg-gradient-to-br from-pink-500 to-orange-400 font-medium rounded-lg hover:scale-110 text-sm px-4 py-2.5 text-center';

      case 'sky':
        return 'text-white bg-gradient-to-br from-sky-500 via-sky-400 to-sky-300 font-medium hover:scale-110 rounded-lg text-sm px-4 py-2.5 text-center';

      case 'yellow':
        return 'text-mainWhite bg-gradient-to-br from-amber-500 via-amber-400  bg-amber-300 hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center';

      case 'blue':
        return 'text-white bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400 hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center';

      case 'purple':
        return 'text-white bg-gradient-to-br from-purple-600 to-blue-500 font-medium hover:scale-110 rounded-lg text-sm px-4 py-2.5 text-center';

      case 'green':
        return 'text-mainWhite bg-gradient-to-br from-emerald-500 to-emerald-300 font-medium hover:scale-110 rounded-lg text-sm px-4 py-2.5 text-center';

      case 'pink':
        return 'text-white bg-gradient-to-br from-pink-600 via-pink-500 to-pink-400 hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center';

      case 'cyan':
        return 'text-white bg-gradient-to-br from-cyan-600 via-cyan-500 to-cyan-400 hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center';

      case 'silver':
        return 'text-white bg-gradient-to-br from-teal-200 to-lime-200 hover:bg-gradient-to-l hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center text-black';

      case 'light-blue':
        return 'text-white bg-gradient-to-br from-cyan-500 to-blue-500  hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center ';

      default:
        return 'text-deepBlack bg-gradient-to-br from-slate-200 via-slate-100 to-slate-50 hover:scale-110 font-medium rounded-lg text-sm px-4 py-2.5 text-center';
    }
  };
  return (
    <button type="button" className={customClassName()} onClick={handleFilter}>
      {tagName}
    </button>
  );
};

export default PillButton;
